module.exports = __webpack_public_path__ + "static/semantic-placeholder-content-image-card-87636ddad538434455c2c9c809fc1d76.gif";